/**
 * Registro de servidores monitorados, carregado de `GET monitoramento/servidores`.
 */

let SERVIDORES = [];
let promessa = null;

export function carregarServidores(http, forcar = false) {
    if (forcar) {
        promessa = null;
    }

    if (!promessa) {
        promessa = http.get('monitoramento/servidores')
            .then(({ data }) => {
                SERVIDORES = data || [];
                return SERVIDORES;
            })
            .catch((e) => {
                promessa = null;
                throw e;
            });
    }

    return promessa;
}

export function invalidar() {
    promessa = null;
}

export function servidores() {
    return SERVIDORES;
}

export function ativos() {
    return SERVIDORES.filter(s => s.ativo);
}

export function servidor(host) {
    return SERVIDORES.find(s => s.host === host) || null;
}

export function nomeDoHost(host) {
    const encontrado = servidor(host);
    return encontrado ? encontrado.nome : host;
}

export const PAPEIS = [
    { value: 'api', text: 'API / Banco', icone: 'mdi-server' },
    { value: 'whatsapp', text: 'WhatsApp', icone: 'mdi-whatsapp' },
    { value: 'socket', text: 'Socket', icone: 'mdi-transit-connection-variant' },
    { value: 'backup', text: 'Backup', icone: 'mdi-content-save-outline' },
    { value: 'outro', text: 'Outro', icone: 'mdi-server-outline' },
];

export function iconeDoPapel(papel) {
    const encontrado = PAPEIS.find(p => p.value === papel);
    return encontrado ? encontrado.icone : 'mdi-server-outline';
}

export function textoDoPapel(papel) {
    const encontrado = PAPEIS.find(p => p.value === papel);
    return encontrado ? encontrado.text : papel;
}

export function corDaSituacao(situacao) {
    return {
        ok: 'green darken-1',
        aviso: 'amber darken-2',
        critico: 'red darken-1',
        sem_coleta: 'red darken-4',
        aguardando: 'grey',
    }[situacao] || 'grey';
}

export function textoDaSituacao(situacao) {
    return {
        ok: 'OK',
        aviso: 'Atenção',
        critico: 'Crítico',
        sem_coleta: 'Sem coleta',
        aguardando: 'Aguardando 1ª coleta',
    }[situacao] || situacao;
}
